<template>
    <b-card-body>
        <b-row class=" mb-3">
            <b-col cols="6">
                <p class="mt-3">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </p>
            </b-col>
            <b-col cols="6" class="text-right">
                <b-button-group>
                    <b-button variant="blue-button me-2" size="md" @click="shouldShowFilters = !shouldShowFilters">
                        <span style="white-space: nowrap">
                            {{ $translate('filters') }}
                            <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                }`"></b-icon>
                        </span>
                    </b-button>
                    <b-button variant="blue-button" size="md" @click="resetFilters" v-b-tooltip.hover
                        :title="$translate('reset_filters')">
                        <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                    </b-button>
                </b-button-group>
            </b-col>

            <b-col class="text-right">
                <slot></slot>
            </b-col>
        </b-row>

        <RatingQueryFilter v-show="shouldShowFilters" :roles="roles" :officers="officers" ref="queryFilter"
            v-model="filters" :disabled-officers="!hasPermissionView" />

        <b-table class="mt-3" :fields="fields" responsive :items="items" :busy="loading">
            <template #cell(id)="row">
                <b-button @click="ordersRefRoute(row.item)" variant="pink-button">
                    <img src="@/assets/images/icon/view.svg">
                </b-button>
            </template>
            <template #cell(feedback)="row">
                <b-form-rating body-class="p-0 text-left" v-model="row.item.feedback" no-border readonly>
                </b-form-rating>
            </template>
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <!-- <strong>{{ $translate('loading') }}</strong> -->
                </div>
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-pagination class="float-right mt-4" v-model="pagination.page" :total-rows="pagination.total"
                    :per-page="pagination.pageSize" aria-controls="customerTable" :next-text="$translate('next')"
                    :prev-text="$translate('previous')" pills align="center"></b-pagination>
            </b-col>
        </b-row>
    </b-card-body>
</template>
<script>
const _ = require('lodash')
import popupMixins from '@/mixins/popupMixins'
import RatingQueryFilter from './RatingQueryFilter.vue'
import moment from 'moment'

// import LocationSection from '@/views/Location/LocationSection'
// import CustomerUsers from '@/components/CustomerUsers.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
const defaultFilters = Object.freeze({
    completion_date_from: null,
    completion_date_to: null,
    driver_id: null,
    role_id: null,
    rating: null,
})

export default {
    name: 'customers-ratinglistitem',
    components: { RatingQueryFilter },
    props: ['title', 'items', 'customer_id'],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            shouldShowFilters: false,
            reportType: 'order_rating_details',
            filters: { ...defaultFilters },
            tabIndex: 0,
            loading: false,
            locationSectionData: {},
            count: 0,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'description', label: this.$translate('description') },
                { key: 'reference_no', label: this.$translate('reference_no') },
                {
                    key: 'feedback',
                    label: this.$translate('rating'),
                    formatter: (key, value, item) =>
                        item ? item.feedback : 10,
                },
                { key: 'feedback_comments', label: this.$translate('comments') },
                {
                    key: 'driver_id',
                    label: this.$translate('officer'),
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'role',
                    label: this.$translate('role'),
                    formatter: (value, key, item) => {
                        return (
                            item &&
                            item.driver &&
                            item.driver.roles &&
                            item.driver.roles[0].role.name
                        )
                    },
                },
                {
                    key: 'completed_at',
                    label: this.$translate('completion_date'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },
                {
                    key: 'updated_at',
                    label: this.$translate('date_and_time'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value),
                },
            ]
        },
        componentName() { return this.$translate('customer_rating') },
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        roles() {
            return this.$store.state.roles.items
        },
        pagination() {
            return this.$store.state.orders.pagination || {}
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        ordersRoute() {
            return `/ams/activities?page=1&query=&customer_id=${this.model.id}&entity=1`
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
    },

    created() {
        // this.$store.dispatch('customerSegments/fetchAll')
        // this.$store.dispatch('customerGroups/fetchAll')
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('roles/fetchAll')
    },
    watch: {
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        'pagination.page': function () {
            this.doSearch()
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },
    methods: {
        getReportQuery(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        resetFilters() {
            this.filters = { ...defaultFilters }
            this.doSearch()
        },
        ordersRefRoute(OrderData) {
            this.$router.push(
                `/ams/activities?page=1&query=${OrderData.reference_no}&customer_id=${this.customer_id}&entity=1`
            )
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD hh:mm:ss a'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        doSearch() {
            try {
                this.loading = true
                const id = this.id
                let {
                    query,
                    filters,
                    pagination: { page },
                } = this
                page = parseInt(page) || 1
                filters.customer_id = this.customer_id
                this.$store
                    .dispatch('orders/fetch', {
                        query,
                        page,
                        filters,
                        id,
                    })
                    .then(() => {
                        this.loading = false
                    })

                // })
            } catch (err) {
                console.error('loading error', err)
            }
        },
    },
}
</script>
<style></style>
